import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthPage } from './pages/auth.page';
import { AuthSilentPage } from './pages/auth-silent.page';

const routes: Routes = [
    {
        path: 'auth',
        component: AuthPage,
    },
    {
        path: 'auth/silent',
        component: AuthSilentPage,
    },
];

export const AUTH_ROUTING: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
